import { render, staticRenderFns } from "./PaymentFormComponent.vue?vue&type=template&id=585fcf3a&scoped=true&lang=pug"
import script from "./PaymentFormComponent.vue?vue&type=script&lang=ts"
export * from "./PaymentFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./PaymentFormComponent.vue?vue&type=style&index=0&id=585fcf3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fcf3a",
  null
  
)

export default component.exports